import { AxiosResponse } from 'axios'
import { privateApi } from 'api'

export interface IOzonDropoffPoint {
  dropoff_point_id: number | string
  name?: string
  full_address?: string
  address?: string | IOzonDropoffLocation
  location?: IOzonDropoffLocation
  coordinates?: IOzonDropoffLocation
  latitude?: number | string
  longitude?: number | string
  work_time?: string
}

export interface IOzonDropoffLocation {
  full_address?: string
  address?: string
  latitude?: number | string
  longitude?: number | string
  lat?: number | string
  lon?: number | string
  lng?: number | string
}

export interface IOzonDropoffSearchResponse {
  dropoff_points: IOzonDropoffPoint[]
  next_cursor?: string | null
  pagination?: { next_cursor?: string | null }
}

export interface IOzonDropoffViewport {
  left_bottom: { latitude: number; longitude: number }
  right_top: { latitude: number; longitude: number }
}

export const ozonDeliveryApi = {
  getDropoffPointInfo(id: number): Promise<AxiosResponse<{ dropoff_points: IOzonDropoffPoint[] }>> {
    return privateApi.post('ozon/dropoff-point/info', { dropoff_point_ids: [id] })
  },
  getDropoffPointsInfo(ids: number[]): Promise<AxiosResponse<{ dropoff_points: IOzonDropoffPoint[] }>> {
    return privateApi.post('ozon/dropoff-point/info', { dropoff_point_ids: ids })
  },
  searchDropoffPoints(addressSearch: string, viewport: IOzonDropoffViewport, cursor: string | null): Promise<AxiosResponse<IOzonDropoffSearchResponse>> {
    return privateApi.post('ozon/dropoff-point/search', {
      filters: { is_bulky: false, address_search: addressSearch, viewport },
      pagination: { limit: 100, ...(cursor ? { cursor } : {}) }
    })
  }
}
